import { type ReactElement, useEffect, type ReactNode, useState } from "react"
import { RootState } from "src/app/store";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "src/features/authentication/hooks/userAuth";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom"
import { useIdleTimer } from "react-idle-timer";
import { DealerHome } from "src/features/dealers"
import LogoutModal from "src/features/authentication/components/LogoutModal";
import { AppDispatch } from "src/app/store";
import { getEndUsersByDealerID } from "src/features/dealers/hooks/endUsers";
import Spinner from "src/components/Spinner";

export interface DealerHomePageProps {
}

export function DealerHomePage(props: DealerHomePageProps): ReactElement {
        const location = useLocation();
        let dealerId = location.state?.dealerID;
        const history = location.state?.from;
        const navigate = useNavigate();
        const { authUser } = useSelector((state: RootState) => state.auth);
        const { endUsersLoading } = useSelector((state: RootState) => state.endUsers);
        {/* const { dealer } = useSelector((state: RootState) => state.dealer); */ }
        const [showLogoutModal, setShowLogoutModal] = useState(false);
        const dispatch = useDispatch<AppDispatch>();

        const onIdle = () => {
                if (showLogoutModal) {
                        dispatch(logoutUser(authUser));
                        dispatch({ type: "RESET" });
                }
                setShowLogoutModal(false);
        }

        const staySignedIn = () => {
                setShowLogoutModal(false);
                reset();
        }

        const onPrompt = () => {
                setShowLogoutModal(true);
        }

        const { getRemainingTime, reset } = useIdleTimer({
                onIdle,
                onPrompt,
                timeout: 1000 * 60 * 8,
                promptBeforeIdle: 1000 * 60 * 3,
                debounce: 500
        })

        // useEffect(() => {
        //         dispatch(getEndUsersByDealerID(dealerId));
        // }, [])

        return <>
                <DealerHome dealerId={dealerId} browhistory={history} />
                {showLogoutModal ?
                        <LogoutModal title="Logout Modal" isOpen={showLogoutModal} onClose={staySignedIn} />
                        :
                        <></>
                }

        </>
}
